import React from 'react';

const BetContainer = () => {
    return (
        <div className="bet-container">
            <span>BET 5</span>
        </div>
    );
};

export default React.memo(BetContainer);